import React, { useState, useRef } from "react";

import "./Diagnosticians.css";
import Header from "../Shared/Header/Header";
import SubHeader from '../Shared/SubHeader/SubHeader';
import Footer from "../Shared/Footer/Footer";
import zdjNatMac from "../../images/home/img_natalia_mackowiak.jpg";
import zdjAleksSaw from '../../images/home/img_aleksandra_sawicka.jpg';
import zdjMonKos from '../../images/home/img_monika_kosowska.jpg';
import { Link } from "react-router-dom";
import { BsFillArrowRightCircleFill } from "react-icons/bs";


const Diagnosticians = () => {

  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);

  // refs for scrolling
  const descRef1 = useRef(null);
  const descRef2 = useRef(null);
  const descRef3 = useRef(null);

  const handleExpand = (num) => {
    switch (num) {
      case 1:
        setExpanded1(prev => !prev);
        if (!expanded1 && descRef1.current) descRef1.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        break;
      case 2:
        setExpanded2(prev => !prev);
        if (!expanded2 && descRef2.current) descRef2.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        break;
      case 3:
        setExpanded3(prev => !prev);
        if (!expanded3 && descRef3.current) descRef3.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Header />
      <SubHeader title="Specjaliści" 
      subtitle="Poznaj naszych psychologów – doświadczonych specjalistów, którzy z empatią i zaangażowaniem wspierają swoich pacjentów." 
      />
      
      <section id="doctors" className="doctors">
        <div className="container">
          <div className="row">
          <div className="col-lg-6 mt-3">
              <div className="member d-flex align-items-start">
                <div className="pic">
                  {
                    <img
                      src={zdjNatMac}
                      className="img-fluid"
                      alt="Natalia Maćkowiak"
                    />
                  }
                </div>
                <div className="member-info">
                  <h4>Natalia Maćkowiak</h4>
                  <span>Psycholog</span>
                  <p className={`description ${!expanded3 ? "line-clamp-6" : "line-expanded"}`}>
                  Jestem magistrem psychologii, a swoje doświadczenie zawodowe zdobywałam, pracując z 
                  dziećmi z orzeczeniami w przedszkolu. Ukończyłam również staż diagnostyczno-terapeutyczny 
                  w nurcie integracyjnym, obejmujący moduły diagnozy oraz interwencji kryzysowej. 
                  Obecnie specjalizuję się w diagnozie dorosłych, wykorzystując kwestionariusz DIVA – narzędzie 
                  służące do oceny objawów ADHD u osób dorosłych. W swojej pracy stawiam na rzetelność, uważność i 
                  indywidualne podejście do każdej osoby.
                  <br />
                  „Zrozumieć siebie – to największy krok do wolności.”{" "}
                  </p>
                  <button
                    className="expand-toggle"
                    onClick={() => setExpanded3((prev) => !prev)}
                  >
                    {expanded3 ? "Pokaż mniej" : "Pokaż więcej"}
                  </button>
                  <div className="text-end">
                    <Link to={`/umow-wizyte?firstName=${encodeURIComponent("Natalia")}&lastName=${encodeURIComponent("Maćkowiak")}`} className="more-btn">
                      <BsFillArrowRightCircleFill /> Umów się na wizytę
                      <i className="bx bx-chevron-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
{/*             <div className="col-lg-6 mt-3"> */}
{/*               <div className="member d-flex align-items-start"> */}
{/*                 <div className="pic"> */}
{/*                   { */}
{/*                     <img */}
{/*                       src={zdjAleksSaw} */}
{/*                       className="img-fluid" */}
{/*                       alt="Aleksandra Sawicka" */}
{/*                     /> */}
{/*                   } */}
{/*                 </div> */}
{/*                 <div className="member-info"> */}
{/*                   <h4>Aleksandra Sawicka</h4> */}
{/*                   <span>Psycholog</span> */}
{/*                   <p className={`description ${!expanded1 ? "line-clamp-6" : "line-expanded"}`}> */}
{/*                     Jestem psychologiem pasjonującym się neuroróżnorodnością. Studia */}
{/*                     ukończyłam na uniwersytecie SWPS. Swoją karierę zawodową rozpoczęłam od */}
{/*                     pracy w zespole pracy środowiskowej, współpracując z dziećmi/ dorosłymi w */}
{/*                     spektrum autyzmu, ADHD, upośledzeniem intelektualnym oraz ich rodzinami. */}
{/*                     Następne lata spędziłam pracując w ośrodku integracji społecznej dla osób */}
{/*                     dorosłych z ASD. Aktualnie skupiam się na pracy i poszerzaniu swoich */}
{/*                     umiejętności w obszarze diagnostyki ADHD.{" "} */}
{/*                   </p> */}
{/*                   <button */}
{/*                     className="expand-toggle" */}
{/*                     onClick={() => setExpanded1((prev) => !prev)} */}
{/*                   > */}
{/*                     {expanded1 ? "Pokaż mniej" : "Pokaż więcej"} */}
{/*                   </button> */}
{/*                   <div className="text-end"> */}
{/*                     <Link to={`/umow-wizyte?firstName=${encodeURIComponent("Aleksandra")}&lastName=${encodeURIComponent("Sawicka")}`} className="more-btn"> */}
{/*                       <BsFillArrowRightCircleFill /> Umów się na wizytę */}
{/*                       <i className="bx bx-chevron-right"></i> */}
{/*                     </Link> */}
{/*                   </div> */}
{/*                 </div> */}
{/*               </div> */}
{/*             </div> */}
{/*             <div className="col-lg-6 mt-3"> */}
{/*               <div className="member d-flex align-items-start"> */}
{/*                 <div className="pic"> */}
{/*                   { */}
{/*                     <img */}
{/*                       src={zdjMonKos} */}
{/*                       className="img-fluid" */}
{/*                       alt="Monika Kosowska" */}
{/*                     /> */}
{/*                   } */}
{/*                 </div> */}
{/*                 <div className="member-info"> */}
{/*                   <h4>Monika Kosowska</h4> */}
{/*                   <span>Psycholog</span> */}
{/*                   <p className={`description ${!expanded2 ? "line-clamp-6" : "line-expanded"}`}> */}
{/*                     Jestem psychologiem z doświadczeniem w pracy terapeutycznej z osobami dorosłymi oraz dziećmi.  */}
{/*                     Ukończyłam studia magisterskie na kierunku psychologia o specjalności klinicznej na SWPS Uniwersytecie  */}
{/*                     Humanistycznospołecznym w Warszawie. Pracuję z klientami indywidualnie, oferując wsparcie w rozwoju  */}
{/*                     wewnętrznym, budowaniu poczucia własnej wartości oraz w osiąganiu większej samodzielności życiowej.  */}
{/*                     Doświadczenie zawodowe zdobywałam pracując indywidualnie oraz grupowo w poradni psychologiczno-psychoterapeutycznej,  */}
{/*                     klubie środowiskowym,  ZPŚ i ośrodku integracji społecznej. W pracy terapeutycznej ważna jest dla mnie  */}
{/*                     relacja oparta na empatii, zrozumieniu i szacunku dla indywidualności każdej osoby.{" "} */}
{/*                   </p> */}
{/*                   <button */}
{/*                     className="expand-toggle" */}
{/*                     onClick={() => setExpanded2((prev) => !prev)} */}
{/*                   > */}
{/*                     {expanded2 ? "Pokaż mniej" : "Pokaż więcej"} */}
{/*                   </button> */}
{/*                   <div className="text-end"> */}
{/*                     <Link to={`/umow-wizyte?firstName=${encodeURIComponent("Monika")}&lastName=${encodeURIComponent("Kosowska")}`} className="more-btn"> */}
{/*                       <BsFillArrowRightCircleFill /> Umów się na wizytę */}
{/*                       <i className="bx bx-chevron-right"></i> */}
{/*                     </Link> */}
{/*                   </div> */}
{/*                 </div> */}
{/*               </div> */}
{/*             </div> */}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Diagnosticians;
